{
    "AgentAdvanced_Fields_LicenceType": "Centre d'appel Type de licence :",
    "AgentAdvanced_Fields_InternalNumber": "Numéro interne :",
    "AgentAdvanced_Fields_CiscoCommonID": "Identité commune de Cisco :",
    "AgentAdvanced_Fields_OverrideMonitoring": "Surveillance de l'annulation :",
    "AgentAdvanced_Fields_WebexCallingUserID": "ID de l'utilisateur de l'appel Webex :",
    "AgentAdvanced_Fields_BroadworksUserID": "ID utilisateur BroadWorks :",
    "AgentAdvanced_Fields_TeamsUserID": "ID utilisateur MS Teams :",
    "AgentAdvanced_Fields_UserPrincipalName": "Nom principal de l'utilisateur (URN) :",
    "AgentAdvanced_Fields_OwningGroupID": "ID du groupe propriétaire :",
    "AgentAdvanced_Fields_OIDOnTelephoneServer": "OID sur le serveur téléphonique :",
    "AgentAdvanced_Fields_OwningDepartment": "Département propriétaire (chemin complet) :",
    "CallCentreLicenceTypes_None": "[Aucun]",
    "CallCentreLicenceTypes_Basic": "De base",
    "CallCentreLicenceTypes_Standard": "Standard",
    "CallCentreLicenceTypes_Premium": "Prime",
    "NAME": "AgentAdvanced"
}